let de = {
  translations: {
    features: 'Funktionen',
  },
}

export default de
